export const GetInitials = (fullName: string) => {
  const list = fullName.split(" ").map((text) => text[0]);
  return list.join("");
};
